import { useEffect } from 'react';

import { useCustomerPersonaActions } from './useCustomerPersonaActions';

const getNewPersonasList = (items) =>
  (items && items.filter(({ isNew }) => isNew)) || [];

export const useSelectNewlyCreatedPersona = (customerPersonas, onSelect) => {
  const customerPersonaStoreActions = useCustomerPersonaActions();

  useEffect(() => {
    const newPersonasList = getNewPersonasList(customerPersonas);

    newPersonasList.forEach(({ id }) => {
      onSelect(id);
      customerPersonaStoreActions.clearPersonaNewStatus(id);
    });
  }, [customerPersonas, onSelect, customerPersonaStoreActions]);
};
